import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Cargar sesión al refrescar
  useEffect(() => {
    const stored = localStorage.getItem("sessionKey");
    if (stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {
        localStorage.removeItem("sessionKey");
      }
    }
  }, []);

  const login = (data) => {
    localStorage.setItem("sessionKey", JSON.stringify(data));
    setUser(data);
  };

  const logout = () => {
    localStorage.removeItem("sessionKey");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
